// @flow
import type { Route } from '@dpdgroupuk/fmx-ui/types';

export const getDriverId = (route: Route): string =>
  `${route.depotCode}*${route.driverCode}`;

export const isDriverAssigned = (route: Route): boolean =>
  !!(route.depotCode && route.driverCode);
